import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Card from 'components/Layout/Card';
import CreatePost from 'components/Layout/CreatePost';
import PostList from 'components/Layout/PostList';
import ChatProfile from 'components/Layout/ChatProfile';
import Profile from 'components/Layout/Profile';
import DropdownButton from 'components/form/DropdownButton';
import { getDataFromLocalStorage, titleCaseString } from 'utils/helpers';
import SeachInput from 'components/form/SeachInput';
import MultipleSelect from 'components/form/MultipleSelect';
import Button from 'components/form/Button';
import TabLayout from 'components/Layout/TabLayout';
import Dropdown from 'components/form/Dropdown';
import ReportRequestList from './ReportRequestList/ReportRequestList';
import DeleteRequestList from './DeleteRequestList';

// const hashTags = [
//   "iferp",
//   "conference",
//   "ceo",
//   "books",
//   "events",
//   "work",
//   "publications",
//   "mnc",
//   "digital",
// ];

const Post = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));
  const { memberType, cType } = params;
  const reduxData = useSelector((state) => state.global);
  const { postCategoryList, myGroupsList } = reduxData || {};
  const [sortPost, setSortPost] = useState('latest');
  const [isPostLoading, setIsPostLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [timer, setTimer] = useState('');
  const [categoryValue, setCategoryValue] = useState('');
  const [categoryIDs, setCategoryIDs] = useState('');
  const [count, setCount] = useState(0);

  const redirect = (optionType) => {
    if (!isPostLoading) {
      setSortPost('latest');
      navigate(`/${memberType}/network-management/network/posts/${optionType}`);
    }
  };

  const handleSearch = (e) => {
    let value = e.target.value;
    setSearchText(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      let time = timer;
      clearTimeout(time);
      time = setTimeout(() => {
        setCount((prevCount) => prevCount + 1);
      }, 800);
      setTimer(time);
    }
  };

  const handleOnClick = () => {
    setCount((prevCount) => prevCount + 1);
  };

  const handleCategoryChange = (e) => {
    const IDs = e?.target?.data?.map((items) => items?.id);
    setCategoryIDs(IDs);
    setCategoryValue(e.target.value);
    if (IDs?.length === 0) {
      setCategoryIDs('');
      setCount((prevCount) => prevCount + 1);
    }
  };

  const handelFilter = (data) => {
    if (data) {
      setCount((prevCount) => prevCount + 1);
    }
  };

  const userType = getDataFromLocalStorage('user_type');
  const access = {
    institutionTab: ['2', '3', '5'].includes(userType),
    companyTab: ['4'].includes(userType),
    deletedPostsTab: ['0', '1'].includes(userType),

  };
  // const activeClass = 'p-2 bg-new-car color-white text-16-500 me-4';
  // const inActiveClass = 'p-2 color-black-olive text-16-500 me-4 pointer';

  const { update: updateAccess, delete: deleteAccess } =
    userDetails?.role_data?.find((item) =>
      ['Network Management', 'My Post and Networks'].includes(
        item?.permission_name
      )
    )?.sub_permission || {};

  const tabs = [
    { key: 'discover-posts', label: 'Research Feeds' },
    { key: 'my-posts', label: 'My Posts' },
    ...(access.institutionTab
      ? [{ key: 'our-institutional-posts', label: 'Our Institutional Posts' }]
      : []),
    ...(access.companyTab
      ? [{ key: 'our-company-posts', label: 'Our Company Posts' }]
      : []),
    { key: 'saved-posts', label: 'Saved Posts' },
    { key: 'pending-ownership', label: 'Pending Ownership' },
    ...(access.deletedPostsTab
      ? [
        // { key: 'deleted-posts', label: 'Deleted Posts' }, 
        { key: 'report-request', label: 'Report Request' },
        { key: 'delete-request', label: 'Delete Posts' }]
      : []),
  ];


  return (
    <div id="post-container" className="flex-grow-1">
      <Card>
        <div className="cpt-10 mb-3">
          <TabLayout
            tabs={tabs}
            activeKey={cType}
            onChange={(key) => redirect(key)}
            variant="underline" // or "background"
          />
        </div>
        {cType !== "report-request" && cType !== "delete-request" &&
          <div className='row cmt-45 cps-24'>
            <div className='col-md-6 col-12'>
              <div className="d-flex justify-content-between align-items-center cmb-16">
                <div className="text-18-500-27 color-title-navy font-poppins">
                  {titleCaseString(sortPost.replace('_', ' '))} Posts
                </div>
              </div>
              <div className="row g-3 align-items-center mb-3">
                <div className="col-12 col-sm-6 col-md-5 col-lg-4">
                  <SeachInput
                    placeholder="Search"
                    value={searchText}
                    onChange={handleSearch}
                    onKeyDown={handleKeyDown}
                    onClick={handleOnClick}
                    isSearchPointer
                    className="small-text-input icon-left"
                    iconClassName="small-search-icon left"
                  />
                </div>

                <div className="col-12 col-sm-6 col-md-5 col-lg-4">
                  <MultipleSelect
                    options={postCategoryList}
                    optionValue="name"
                    id="eventId"
                    value={categoryValue}
                    placeholder="Select"
                    onChange={handleCategoryChange}
                    className="multiselect-small-dropdown"
                  />
                </div>

                {categoryValue && (
                  <div className="col-12 col-sm-auto">
                    <Button
                      text="Apply"
                      btnStyle="primary-dark"
                      className="text-12-500 h-auto text-nowrap w-100 w-sm-auto"
                      onClick={() => handelFilter(categoryIDs)}
                    />
                  </div>
                )}

                <div className="col-12 col-md-2 col-lg-4 d-flex align-items-center flex-wrap">
                  {/* <span className="text-14-400 color-black-olive me-2">Sort By -</span>
                <span className="text-14-500 color-new-car me-1">
                  {titleCaseString(sortPost.replace('_', ' '))}
                </span>
                <DropdownButton
                  parentClass="post-options"
                  className="d-flex justify-content-end"
                  id="iconType"
                  icon={<i className="bi bi-chevron-down text-14-500 ms-2" />}
                >
                  <div className="post-options-list">
                    <div
                      className={`text-14-400 pointer color-black-olive ${sortPost === 'latest' ? 'bg-new-car-light' : ''
                        }`}
                      onClick={() => setSortPost('latest')}
                    >
                      Latest
                    </div>
                    <div
                      className={`text-14-400 pointer color-black-olive ${sortPost === 'trending' ? 'bg-new-car-light' : ''
                        }`}
                      onClick={() => setSortPost('trending')}
                    >
                      Trending
                    </div>
                  </div>
                </DropdownButton> */}
                  <Dropdown
                    id="sortPost"
                    placeholder="Select post category*"
                    value={sortPost}
                    options={[
                      { label: 'Latest', id: 'latest' },
                      { label: 'Trending', id: 'trending' },
                    ]}
                    onChange={(e) => setSortPost(e.target.value)}
                    className="small-dropdown w-100"
                  />
                </div>


              </div>

            </div>
            <div className='col-md-6 col-12'>
              <CreatePost type={cType} />
            </div>
          </div>}
        <div className="row w-100 cmt-10 cps-24">
          <div className="col-md-12 col-12">
            {cType === "report-request" ? (
              <>
                <ReportRequestList />
              </>
            ) : cType === "delete-request" ? (
              <>
                <DeleteRequestList/>
              </>
            ) : (
              <PostList
                type={cType}
                sortType={sortPost}
                setIsPostLoading={setIsPostLoading}
                categoryIDs={categoryIDs}
                searchText={searchText}
                count={count}
                updateAccess={updateAccess}
                deleteAccess={deleteAccess}
              />)}
          </div>

        </div>
      </Card>
    </div>
  );
};
export default Post;

// Old Flow
//  <div className="col-md-4 col-12 mb-3">
//             <ChatProfile />
//             {myGroupsList.length > 0 && (
//               <Card className="mt-3 cps-24 cpe-24 cpt-24 cpb-24">
//                 <div className="d-flex cmb-26">
//                   <div className="text-18-600 color-black-olive">My Groups</div>
//                 </div>
//                 <div className="group-list">
//                   {myGroupsList.map((elem, index) => {
//                     return (
//                       <React.Fragment key={index}>
//                         <div className="group-list-block">
//                           <div className="d-flex align-items-center left-block">
//                             <Profile isRounded text={elem.name} size="s-48" />
//                             <div className="user-details-block ms-3">
//                               <div className="text-14-500 color-black-olive">
//                                 {elem.name}
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                         {myGroupsList.length - 1 !== index && (
//                           <div className="border-bottom mt-3 mb-3" />
//                         )}
//                       </React.Fragment>
//                     );
//                   })}
//                 </div>
//                 {/* <div className="text-15-400 color-new-car mt-3 pointer">
//               View All (8)
//             </div> */}
//               </Card>
//             )}
//             {/* {type === 0 && (
//             <Card className="mt-3 cps-24 cpe-24 cpt-24 cpb-24">
//               <div className="d-flex cmb-26">
//                 <div className="text-18-600 color-black-olive">
//                   Followed Hashtags
//                 </div>
//               </div>
//               <div className="d-flex flex-wrap gap-2">
//                 {hashTags.map((elem, index) => {
//                   return (
//                     <div
//                       className="text-13-500 color-raisin-black bg-new-car-light ps-3 pe-3 pt-2 pb-2"
//                       key={index}
//                     >
//                       {`#${elem}`}
//                     </div>
//                   );
//                 })}
//               </div>
//             </Card>
//           )} */}
//           </div>